import { apiRequest } from "."

export const submitTask = async (token, data)=>{
    try {
        const response = await apiRequest({
            method: 'POST',
            url: '/task',
            data: data,
            token: token,
            header: 'multipart/form-data',
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const getUserTasks = async (token)=>{
    try {
        const response = await apiRequest({
            url: '/task/user',
            token: token,
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const updateUserTask = async (id, token)=>{
    try {
        const response = await apiRequest({
            url: `/task/${id}`,
            method: 'PUT',
            token: token,
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const updateUserTaskProgress = async (id, token, data)=>{
    try {
        const response = await apiRequest({
            url: `/task/progress/${id}`,
            method: 'PUT',
            data: data,
            token: token,
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const getAllTasks = async (token, month)=>{
    try {
        const response = await apiRequest({
            url: `/task/${month}`,
            token: token,
        })

        return response
    } catch (error) {
        console.log(error)
    }
}